import { render, staticRenderFns } from "./PageClaimDetail.vue?vue&type=template&id=68809d03&scoped=true"
import script from "./PageClaimDetail.vue?vue&type=script&lang=ts"
export * from "./PageClaimDetail.vue?vue&type=script&lang=ts"
import style0 from "./PageClaimDetail.vue?vue&type=style&index=0&id=68809d03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68809d03",
  null
  
)

export default component.exports